import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import logoImg from '../image/logo_4.png';

// perm: право профиля, открывающее раздел; adminOnly — раздел только для
// полного админа (профилям не показывается никогда).
const NAV = [
  { id: 'overview',     icon: '⊞', label: 'Обзор',         perm: 'view_overview' },
  { id: 'devices',      icon: '🖨', label: 'Киоски',        perm: 'view_devices'  },
  { id: 'orders',       icon: '🧾', label: 'Заказы',        perm: 'view_orders'   },
  { id: 'stats',        icon: '▤', label: 'Статистика',     perm: 'view_stats'    },
  { id: 'map',          icon: '🗺', label: 'Карта',          perm: 'view_map'      },
  { id: 'settings',     icon: '⚙', label: 'Настройки',      adminOnly: true },
  { id: 'profiles',     icon: '👥', label: 'Профили',        adminOnly: true },
  { id: 'technicians',  icon: '🔧', label: 'Сервисники',     adminOnly: true },
  { id: 'debug-logs',   icon: '📋', label: 'Журнал дебага',  adminOnly: true },
  { id: 'sessions',     icon: '🔐', label: 'Сессии',         adminOnly: true },
  { id: 'console',      icon: '🖥', label: 'Консоль сервера', adminOnly: true },
];

// Видимые разделы для текущей сессии (используется и в App.js для выбора
// стартового таба профиля).
export const visibleNavItems = (isAdmin, can) =>
  NAV.filter(item => (item.adminOnly ? isAdmin : can(item.perm)));

export const MainLayout = ({ children, activeTab, setTab }) => {
  const { logout, isAdmin, can, sessionInfo } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const items = visibleNavItems(isAdmin, can);
  const profileName = sessionInfo?.profile?.display_name || sessionInfo?.profile?.username;

  // Выбор раздела на мобиле закрывает меню
  const selectTab = (id) => { setTab(id); setMenuOpen(false); };

  return (
    <div className="app">
      {/* Фоновое изображение */}
      <div className="bg-image" />

      {/* Мобильная шапка (на десктопе скрыта через CSS) */}
      <div className="mobile-topbar">
        <button className="burger" onClick={() => setMenuOpen(o => !o)} aria-label="Меню">
          ☰
        </button>
        <img src={logoImg} alt="NKEY Kiosk" />
        {!isAdmin && profileName && (
          <span style={{ marginLeft: 'auto', fontSize: '12px', color: 'var(--text-2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            👤 {profileName}
          </span>
        )}
      </div>

      {/* Подложка под открытым мобильным меню */}
      {menuOpen && <div className="sidebar-backdrop" onClick={() => setMenuOpen(false)} />}

      <aside className={`sidebar${menuOpen ? ' open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <img src={logoImg} alt="NKEY Kiosk" />
        </div>

        {/* Кто залогинен */}
        {!isAdmin && profileName && (
          <div style={{ padding: '0 14px 12px', fontSize: '12px', color: 'var(--text-3)' }}>
            👤 <span style={{ color: 'var(--text-1)', fontWeight: 600 }}>{profileName}</span>
          </div>
        )}

        {/* Nav */}
        <ul className="sidebar-nav">
          {items.map(({ id, icon, label }) => (
            <li key={id}>
              <button
                className={`nav-item${activeTab === id ? ' active' : ''}`}
                onClick={() => selectTab(id)}
              >
                <span className="nav-icon">{icon}</span>
                {label}
              </button>
            </li>
          ))}
        </ul>

        {/* Logout */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={logout}>
            ← Выйти
          </button>
        </div>
      </aside>

      <main className="content-area">
        <div className="content-inner">
          {children}
        </div>
      </main>
    </div>
  );
};
